export default __webpack_public_path__ + "assets/homescreentutorialstep2figureSafari.png";